var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var api = require('../api.js');
var dsn = require('../utils-hoist/dsn.js');
var envelope = require('../utils-hoist/envelope.js');

/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */
function eventFromEnvelope(env, types) {
  var event;
  envelope.forEachEnvelopeItem(env, function (item, type) {
    if (types.includes(type)) {
      event = Array.isArray(item) ? item[1] : undefined;
    }
    // bail out if we found an event
    return !!event;
  });
  return event;
}

/**
 * Creates a transport that overrides the release on all events.
 */
function makeOverrideReleaseTransport(createTransport, release) {
  return function (options) {
    var transport = createTransport(options);
    return _objectSpread(_objectSpread({}, transport), {}, {
      send: function () {
        var _send = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(envelope) {
          var event;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                event = eventFromEnvelope(envelope, ['event', 'transaction', 'profile', 'replay_event']);
                if (event) {
                  event.release = release;
                }
                return _context.abrupt("return", transport.send(envelope));
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function send(_x) {
          return _send.apply(this, arguments);
        }
        return send;
      }()
    });
  };
}

/** Overrides the DSN in the envelope header  */
function overrideDsn(envelope$1, dsn) {
  return envelope.createEnvelope(dsn ? _objectSpread(_objectSpread({}, envelope$1[0]), {}, {
    dsn: dsn
  }) : envelope$1[0], envelope$1[1]);
}

/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */
function makeMultiplexedTransport(createTransport, matcher) {
  return function (options) {
    var fallbackTransport = createTransport(options);
    var otherTransports = new Map();
    function getTransport(dsn$1, release) {
      // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
      // use at the same time
      var key = release ? "".concat(dsn$1, ":").concat(release) : dsn$1;
      var transport = otherTransports.get(key);
      if (!transport) {
        var validatedDsn = dsn.dsnFromString(dsn$1);
        if (!validatedDsn) {
          return undefined;
        }
        var url = api.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
        transport = release ? makeOverrideReleaseTransport(createTransport, release)(_objectSpread(_objectSpread({}, options), {}, {
          url: url
        })) : createTransport(_objectSpread(_objectSpread({}, options), {}, {
          url: url
        }));
        otherTransports.set(key, transport);
      }
      return [dsn$1, transport];
    }
    function send(_x2) {
      return _send2.apply(this, arguments);
    }
    function _send2() {
      _send2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(envelope) {
        var getEvent, transports, transportsWithFallback, results;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              getEvent = function _getEvent(types) {
                var eventTypes = types !== null && types !== void 0 && types.length ? types : ['event'];
                return eventFromEnvelope(envelope, eventTypes);
              };
              transports = matcher({
                envelope: envelope,
                getEvent: getEvent
              }).map(function (result) {
                if (typeof result === 'string') {
                  return getTransport(result, undefined);
                } else {
                  return getTransport(result.dsn, result.release);
                }
              }).filter(function (t) {
                return !!t;
              }); // If we have no transports to send to, use the fallback transport
              // Don't override the DSN in the header for the fallback transport. '' is falsy
              transportsWithFallback = transports.length ? transports : [['', fallbackTransport]];
              _context2.next = 5;
              return Promise.all(transportsWithFallback.map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  dsn = _ref2[0],
                  transport = _ref2[1];
                return transport.send(overrideDsn(envelope, dsn));
              }));
            case 5:
              results = _context2.sent;
              return _context2.abrupt("return", results[0]);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _send2.apply(this, arguments);
    }
    function flush(_x3) {
      return _flush.apply(this, arguments);
    }
    function _flush() {
      _flush = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(timeout) {
        var allTransports, results;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              allTransports = [].concat(_toConsumableArray(otherTransports.values()), [fallbackTransport]);
              _context3.next = 3;
              return Promise.all(allTransports.map(function (transport) {
                return transport.flush(timeout);
              }));
            case 3:
              results = _context3.sent;
              return _context3.abrupt("return", results.every(function (r) {
                return r;
              }));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _flush.apply(this, arguments);
    }
    return {
      send: send,
      flush: flush
    };
  };
}
exports.eventFromEnvelope = eventFromEnvelope;
exports.makeMultiplexedTransport = makeMultiplexedTransport;